export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.32 439c39.9-114.182 161.9-192.328 366-234.438C570.421 162.452 702.396 75.931 762.245-1h149.622v440H.32z\" fill=\"#EBF5FB\"/>",
  "attrs": {
    "width": "829",
    "height": "439",
    "viewBox": "0 0 829 439",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};